export default __webpack_public_path__ + "static/MediaContentThree-f8f0b5b99bc9b4f2776388dd25f7199a.webp";